import { logger } from 'src/app/common/services/logging/logging.service';
import { VoiceRecognitionService } from './voice-recognition.service';

declare var webkitSpeechRecognition: any;

export class VoiceRecognitionWebService extends VoiceRecognitionService {

    private recognition: any;

    constructor() {
        super();
        let isSupport = ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window);
        if (isSupport) {
            this.recognition = new webkitSpeechRecognition();
            this.recognition.continuous = true;
            this.recognition.interimResults = true;
            this.recognition.lang = 'en-US';
        }
        this.isDeviceSupport$.next(isSupport);
        this.isDeviceSupport$.complete();
    }

    override init() {
        this.recognition.addEventListener('result', (event: any) => {
            const transcript = Array.from(event.results)
                .map((result: any) => result[0])
                .map((result: any) => result.transcript)
                .join(' ');
            logger.debug("result", transcript);
            this.message$.next(transcript);
            this.updateSilentTimer();
        });
    }

    override async start() {
        if ((this.isListening$.value)) {
            logger.error("start was called but is listening is true");
            return;
        }

        // await this.playAudio();

        this.message$.next("");
        this.isListening$.next(true);

        this.recognition.start();

    }

    override stop() {
        if (!(this.isListening$.value)) {
            logger.error("stop was called but is listening is false");
            return;
        }

        this.recognition.stop();
        this.isListening$.next(false);

        this.isCompleted$.next(true);
        this.isCompleted$.complete();
    }
}
